<template>
  <div class="content">
    <!-- 上白板step -->
    <div class="nav-border">
      <!-- 按钮 -->
      <div class="nav_but">
        <a-button class="bottom-button" type="primary" ghost @click="cancle">返回</a-button>
      </div>
    </div>

    <!-- body -->
    <div class="body">
      <div class="body-content public_scrill">
        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">订单信息</div>
        </div>

        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid.field"
          :data-source="relevanceBatch_grid.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{index + 1}}
          </span>
          <!-- 产品类型 -->
          <span slot="prType" slot-scope="text, record">
            {{ text | DictionaryFilter('PRO_TYPE') }}
          </span>
          <!-- 订单来源 -->
          <!-- <span slot="orderSource" slot-scope="text, record, index">
            小程序订单
          </span> -->
        </a-table>

        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">商品信息</div>
        </div>

        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid_good.field"
          :data-source="relevanceBatch_grid_good.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid_good.height,x:relevanceBatch_grid_good.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{index + 1}}
          </span>
          <!-- 支付方式 -->
          <span slot="payType" slot-scope="text, record, index">
            微信直连
          </span>
          <!-- 图例 -->
          <span slot="prAttId" slot-scope="text, record">
            <img
              style="height: 50px;max-width: 100%; margin-right: 4px"
              :src="url + record.prAttId"
              @click="handleImg(record.prAttId)"
            />
          </span>
        </a-table>

         <!-- 表头 -->
         <div class="content_one">
          <div class="form_title">赠予信息</div>
        </div>

        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid_gift.field"
          :data-source="relevanceBatch_grid_gift.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid_gift.height,x:relevanceBatch_grid_gift.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{index + 1}}
          </span>
        </a-table>

        <!-- 表头 -->
        <div class="content_one" v-if="addressVisible">
          <div class="form_title">物流信息</div>
        </div>

        <!-- 展示框 -->
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="logisticsList" v-if="addressVisible">
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="物流公司:" prop="logisticsComp">
                <a-input v-model="logisticsList.logisticsComp" :allowClear="true" disabled/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="运单号:" prop="waybillNum">
                <a-input v-model="logisticsList.waybillNum" :allowClear="true" disabled/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
        

        <!-- 表头 -->
        <div class="content_one" v-if="addressVisible">
          <div class="form_title">收获地址</div>
        </div>

        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid_address.field"
          :data-source="relevanceBatch_grid_address.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid_address.height,x:relevanceBatch_grid_address.width}"
          :pagination="false"
          v-if="addressVisible"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index" :key="index">
            {{index+1}}
          </span>
        </a-table>

        <!-- 表头 -->
        <div class="content_one" v-if="addressVisible">
          <div class="form_title">实体卡信息</div>
        </div>

        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid_card.field"
          :data-source="relevanceBatch_grid_card.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid_card.height,x:relevanceBatch_grid_card.width}"
          :pagination="false"
          v-if="addressVisible"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index" :key="index">
            {{index+1}}
          </span>
           <!-- 图例 -->
           <span slot="attId" slot-scope="text, record">
            <img
              style="height: 50px;max-width: 100%; margin-right: 4px"
              :src="url + record.attId"
              @click="handleImg(record.attId)"
            />
          </span>
        </a-table>
        
      </div>
    </div>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancelImg"
      class="imgBox"
    >
      <img alt="example" style="width: 100%;height: auto;" :src="previewImage" />
    </a-modal>
  </div>
</template>
    
<script>
import {
  queryOrderDetail,giftDetail
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  props: {
    Title: {
      type: String,
      default: () => "Title",
    },
  },
  data() {
    return {
      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },

      //收获地址显隐
      addressVisible:true,

      //时间轴
      timeLinesList: [],
      timeLinesActive:0,

      //物流信息
      logisticsList: {
        logisticsComp: "",
        waybillNum:""
      },

      //订单备注
      remarkList: {
        orderRemark:""
      },

      //图片
      url: process.env.VUE_APP_PROXY + "base/file/download-file?id=",
      previewVisible: false,
      previewImage: "",

      //订单信息
      relevanceBatch_grid: {
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 20,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "订单编号",
            align: "center",
            width: 110,
            dataIndex: "orderNo",
            ellipsis: true,
          },
          {
            title: "客户编号",
            align: "center",
            width: 110,
            dataIndex: "custNo",
            ellipsis: true,
          },
          {
            title: "产品类型",
            align: "center",
            width: 110,
            dataIndex: "prType",
            ellipsis: true,
            scopedSlots: {
              customRender: "prType",
            },
          },
          // {
          //   title: "订单来源",
          //   colSpan: 1,
          //   align: "center",
          //   width: 110,
          //   ellipsis: true,
          //   dataIndex: "orderSource",
          //   scopedSlots: {
          //     customRender: "orderSource",
          //   },
          // },
        ]
      },

      //商品信息
      relevanceBatch_grid_good: {
        width: 0, // 宽度
        row: [],
        field: [
         {
            title: "序号",
            align: "center",
            width: 30,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "商品图片",
            align: "center",
            width: 120,
            dataIndex: "prAttId",
            scopedSlots: { customRender: "prAttId" },
          },
          {
            title: "商品名称",
            align: "center",
            width:160,
            dataIndex: "prName",
            ellipsis: true,
          },
          {
            title: "商品说明",
            align: "center",
            width: 100,
            dataIndex: "remark",
            ellipsis: true,
          },
          {
            title: "商品单价",
            align: "center",
            width: 100,
            dataIndex: "prPrice",
            ellipsis: true,
          },
          {
            title: "数量",
            colSpan: 1,
            width: 90,
            dataIndex: "giftCount",
            align: "center",
            ellipsis: true,
          },
          {
            title: "小计",
            colSpan: 1,
            width: 90,
            dataIndex: "giftPrice",
            align: "center",
            ellipsis: true,
          }
        ]
      },

      //赠予信息
      relevanceBatch_grid_gift: {
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 20,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "赠与人",
            align: "center",
            width: 110,
            dataIndex: "giftCustName",
            ellipsis: true,
          },
          {
            title: "被赠与人",
            align: "center",
            width: 110,
            dataIndex: "custName",
            ellipsis: true,
          },
          {
            title: "赠予时间",
            align: "center",
            width: 110,
            dataIndex: "createTime",
            ellipsis: true,
          },
          {
            title: "领取时间",
            colSpan: 1,
            align: "center",
            width: 110,
            ellipsis: true,
            dataIndex: "activeTime",
          },
        ]
      },

      //收货地址
      relevanceBatch_grid_address: {
        width: 0, // 宽度
        row: [],
        field: [
        {
            title: "序号",
            align: "center",
            dataIndex: "index",
            width: 50,
            key: "index",
            ellipsis: true,
            scopedSlots: { customRender: "index" },
          },
          {
            title: "收货人",
            align: "center",
            width: 140,
            dataIndex: "consignee",
          },
          {
            title: "手机号",
            align: "center",
            width: 140,
            dataIndex: "phoneNo",
            ellipsis: true,
          },
          {
            title: "收货地址",
            align: "center",
            width: 230,
            dataIndex: "address",
            ellipsis: true,
          }
        ]
      },

      //实体卡信息
      relevanceBatch_grid_card: {
        width: 0, // 宽度
        row: [],
        field: [
        {
            title: "序号",
            align: "center",
            dataIndex: "index",
            width: 50,
            key: "index",
            ellipsis: true,
            scopedSlots: { customRender: "index" },
          },
          {
            title: "实体卡图片",
            align: "center",
            width: 120,
            dataIndex: "attId",
            scopedSlots: { customRender: "attId" },
          },
          {
            title: "实体卡说明",
            align: "center",
            width:160,
            dataIndex: "cardName",
            ellipsis: true,
          },
          {
            title: "卡编号",
            align: "center",
            width: 100,
            dataIndex: "cardNo",
            ellipsis: true,
          },
          {
            title: "数量",
            colSpan: 1,
            width: 90,
            dataIndex: "count",
            align: "center",
            ellipsis: true,
          }
        ]
      },
      //审核
      modalTitle: "",
      giftApply:[],
      receivAddressList:[],
    };
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["PRO_TYPE"]).then((res) => {
      //查询
      this.queryList();
      this.relevanceBatch_grid_gift.row = JSON.parse(this.$route.query.giftData);
    }); 
    this.relevanceBatch_grid.width = 0;
    this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });

    this.relevanceBatch_grid_good.width = 0;
    this.relevanceBatch_grid_good.field.map(item => {
      this.relevanceBatch_grid_good.width += item.width;
    });

    this.relevanceBatch_grid_address.width = 0;
    this.relevanceBatch_grid_address.field.map(item => {
      this.relevanceBatch_grid_address.width += item.width;
    });

    this.relevanceBatch_grid_card.width = 0;
    this.relevanceBatch_grid_card.field.map(item => {
      this.relevanceBatch_grid_card.width += item.width;
    });

    this.relevanceBatch_grid_gift.width = 0;
    this.relevanceBatch_grid_gift.field.map(item => {
      this.relevanceBatch_grid_gift.width += item.width;
    });
  },
  methods: {
    //查询接口
    queryList() {
      this.receivAddressList=[];
      giftDetail({
        giftId:this.$route.query.giftId,
      }).then(res => {
        console.log("赠予信息--------",this.$route.query.giftType, res.content);
        //订单信息
        this.relevanceBatch_grid.row =  res.content.giftOrderList;
         //商品信息
        res.content.giftApply.prAttId =  res.content.prAttId;
        res.content.giftApply.prPrice =  res.content.prPrice;
        res.content.giftApply.address=res.content.giftApply.address+res.content.giftApply.receivAddress;
        this.giftApply.push(res.content.giftApply);
        this.relevanceBatch_grid_good.row = this.giftApply; 
        //如果是实体卡则显示物流信息和收获地址
        if(this.$route.query.giftType == '2'){
            this.addressVisible = false;
        }else{
          //物流信息
          this.logisticsList.logisticsComp = res.content.orderLogistics.logisticsComp;
          this.logisticsList.waybillNum = res.content.orderLogistics.waybillNum;
          //收获地址
          this.receivAddressList.push(res.content.receivAddress);
          this.relevanceBatch_grid_address.row = this.receivAddressList;
          //实体卡信息
          res.content.phyOrderList.forEach(element => {
            element.count='1'
            });
          this.relevanceBatch_grid_card.row =  res.content.phyOrderList;
        }
      });
    },
    // 取消按钮
    cancle() {
      this.$router.go(-1);
    },

    /* 表格图片查看 */
    handleImg(file) {
      this.previewVisible = true;
      this.previewImage = this.url + file;
    },
    /* 表格图片关闭 */
    handleCancelImg() {
      this.previewVisible = false;
    },
  },
};
</script>
    
<style lang="less" scoped>
.content {
  height: 90%;

  .nav-border {
    width: 100%;
    height: 60px;
    background: #fff;
    z-index: 100;
    display: flex;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 2px;
    justify-content: right;
    .nav-lspan {
      font-size: 16px;
      float: left;
      margin: 8px 8px 8px 20px;
      color: black;
      flex: 1;
    }
    .nav_but{
      margin-right: 30px;
    }
  }
  .body {
    display: flex;
    justify-content: space-between;
    height: 88%;
    background: #fff;
    .body-content {
      padding: 15px 20px 15px 20px;
      flex: 1;
      height: 100%;
      overflow-y: auto;

      .content_one{
        height: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
      }
    }
  }
  .blank-border {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    .bottom-button {
      float: right;
      margin-left: 20px;
    }
  }
}

.addbutton {
  border: 1px #009de5 solid;
  color: #009de5;
  float: right;
  margin: 10px;
  z-index: 100;
}

/deep/ .ant-upload-list {
  display: none;
}

.uploadfilelist {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  zoom: 1;

  .fileico {
    margin: 10px;
  }
  .itemname {
  }
  .itemsta {
    float: right;
    margin-right: 30%;
  }
  .download {
    float: right;
    margin: 5px;
  }
  .del {
    float: right;
    margin: 5px;
  }
}
.uploadfilelist:hover {
  background: #f3fbff;
}

/deep/ .form_title{
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  height: 14px;
  color: #16828b;
  padding-left: 5px;
  font-size: 14px;
  border-left: 4px solid #16828b;
}

/deep/ .ant-table-footer{
  display: flex !important;
}
</style>